export default __webpack_public_path__ + "static/lfs-hn-logos-688x48-47611f77f91e30bdbf34e7a421999837.webp";